import { AppState } from '@/store/modules/app/typings'

const start = 2007
const today = new Date().getFullYear()

const state: AppState = {
  copyright: `${today === start ? '' + today : `${start} ~ ${today}`} 云南天谷科技开发有限公司`,
  pending: {}
}

export default state
